<template>
    <vh-modal
        :isOpen="$parent.$data.logoutModal"
        :isCenter="true">

        <vh-modal-body>
            <vh-modal-title>
                Are you sure?
            </vh-modal-title>

            <hr class="vh-margin-small-top">

            <div class="vh-margin-top">
                <p>
                    You are about to logout your account.
                </p>

                <p>Do you want to continue?</p>

                <div class="vh-margin vh-text-right">
                    <vh-button
                        v-if="!submitLoading"
                        type="button"
                        class="vh-margin-small-right"
                        :rounded="'full'"
                        @click="closeModal()">
                        Cancel
                    </vh-button>
                    <vh-button
                        type="button"
                        @click="submit()"
                        :color="'primary'"
                        :rounded="'full'"
                        :loading="submitLoading">
                        Yes
                    </vh-button>
                </div>
            </div>
        </vh-modal-body>
    </vh-modal>
</template>

<script>


import Http from '@/services';

import { Form, Toast, Token } from '@/utils';

export default
{
    name: 'LogOut',

    data()
    {
        return {
            errors: {},

            submitLoading: false,
        };
    },

    methods:
    {
        async submit()
        {
            this.errors = {};

            this.submitLoading = true;
            
            const response = await Http.get(
                '/my-account/logout'
            );

            this.submitLoading = false;

            if (response.status === 200)
            {
                Token.destroy(process.env.VUE_APP_ACCOUNT_STORAGE);

                Token.destroy(process.env.VUE_APP_ACCESS_TOKEN_STORAGE);

                Token.destroy(process.env.VUE_APP_REFRESH_TOKEN_STORAGE);

                this.closeModal();

                Toast.success({
                    message: 'Your account has been logout.'
                });

                window.location.href = process.env.VUE_APP_ACCOUNT_URL;
            }
            else if (response.status === 403)
            {
                let message = 'Sorry, you cannot perform this action.';

                Toast.error({
                    message: response.data.error.description
                        ? response.data.error.description
                        : message,
                });
            }
            else if (response.status === 404)
            {
                let message = 'Data not found. Please try again.';

                Toast.error({
                    message: response.data.error.description
                        ? response.data.error.description
                        : message,
                });
            }
            else
            {
                let message = 'Something went wrong. Please try again.';

                Toast.error({
                    message: response.data.error.description
                        ? response.data.error.description
                        : message,
                });
            }
        },

        hasError(name = null)
        {
            return Form.hasError(this.errors, name);
        },

        closeModal()
        {
            this.$parent.toggleModal('logout', false);
        },
    },
};
</script>
